import { useState } from 'react';
import { getBitrixPlacementDeals } from 'src/api';
import { useGetAuthData } from 'src/hooks';
import { IBitrixDealPlacement } from 'src/store/crosstable/reducer';

export const useCrmBitrixDeal = () => {
  const { getJWT } = useGetAuthData();
  const jwt = getJWT();
  const [placementDeal, setPlacementDeal] = useState<IBitrixDealPlacement>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const getPlacementDeals = async (placementId: string | null) => {
    setIsLoading(true);
    const resp = await getBitrixPlacementDeals(jwt, placementId || '');
    // Keep the previous data on a failed refresh instead of blanking the panel.
    if (resp?.ok && resp.data) {
      setPlacementDeal(resp.data);
    }
    setIsLoading(false);
    return resp;
  };
  return {
    isLoading,
    setIsLoading,
    placementDeal,
    getPlacementDeals,
    setPlacementDeal,
  };
};
